import { Events } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams, ResponseContentType } from '@angular/http';
import { AuthProvider } from '../auth/auth';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage';
import { GlobalProvider } from "../../providers/global/global";
import { TranslateService } from '@ngx-translate/core';
 //let this.global.apiUrl = 'https://api.picmasters.de.w016f694.kasserver.com/api/';
 //
 // let this.global.apiUrl = 'https://api.picmasters.de/api/';
  // let this.global.apiUrl = 'http://plentyclip.apps/api/';
@Injectable()
export class TemplatesProvider {
 
	data: any;

	templates:any = [];
  orderInitialTemplate:any;
  forUserId:any; // Will be used to pass for identification as user

  constructor(public http: Http, public authService: AuthProvider, public storage: Storage, 
  	public global: GlobalProvider, public translate: TranslateService, public events: Events) {
  	
 
  }

  setForUserId(forUserId){
    this.forUserId = forUserId;
  }

 getBanners(page){
 
    return new Promise((resolve, reject) => {
 

 	this.storage.get('token').then((token) => {
	      let headers = new Headers();

	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);

	      let params = new URLSearchParams();
	      	params.append('page', page);
	      	params.append('with', 'template_entries');
	      	params.append('search', 'subtype:banner');
	 		//alert('Get Template with token:' + token);   
	      this.http.get(this.global.apiUrl+'get-banners', {headers: headers, params: params})
	        .map(res => res.json())
	        .subscribe(data => {
	      
	          resolve(data.data);
	        }, (err) => {
	          reject(err);
	        });
	    });
 	});
 
  }


 resetGlobalTemplates(){
	 
 	this.templates = [];
 	// Get fresh template list
 	this.getGlobalTemplates();
 }

 removeGlobalTemplates(){
	this.templates = [];
 }
 
 getGlobalTemplates(){

	// Clean out all order bounded templates
	if(this.templates && this.templates.length > 0){
		this.templates = this.templates.filter((item) => !item.order_id);
	}

	

 	// Get templates if not already loaded or reseted by resetGlobalTemplates()
 	if (!this.templates || this.templates.length == 0) {
	 	this.storage.get('token').then((token) => {
		      let headers = new Headers();

		      headers.append('X-Requested-With', 'XMLHttpRequest');
		      headers.append('Authorization', 'Bearer ' + token);
		      headers.append('X-localization', this.translate.currentLang);

		      let params = new URLSearchParams();
		      	params.append('with', 'swatches');
            params.append('includeDefault', 'true');
            params.append('forUserId', this.forUserId);
		 		//alert('Get Template with token:' + token);   
		      this.http.get(this.global.apiUrl+'templates', {headers: headers, params: params})
		        .map(res => res.json())
		        .subscribe(data => {

					console.log("GOT FRESH TEMPLATES FROM SERVER", data.data);

					// Add current order bound template to list 1 of 2
					if(this.orderInitialTemplate && !this.orderInitialTemplate.type.includes('default')){
						console.log("Push initialTemplate to templates stack 1of2:", this.orderInitialTemplate);
						this.templates.push(this.orderInitialTemplate);
						this.orderInitialTemplate = null;
					}

					data.data.forEach(template => {
						this.templates.push(template);
					});

					// Publish all templates to create-order so that one default template can be assigned to order
					this.events.publish('templates:gotGlobalTemplates', this.templates);

					// this.templates.push(data.data);
				  
				  
		      	console.log("TEMPLATES FROM getGlobalTemplates:", this.templates);
		        }, (err) => {
		        	console.log("ERROR on getGlobalTemplates()", err);
		        });
		 });
 	}else{

		console.log("DO NOT GET FRESH TEMPLATES, instead release templates:gotGlobalTemplates event for templates:", this.templates);
		 // Publish all templates if any available to create-order so that one default template can be assigned to order
		 this.events.publish('templates:gotGlobalTemplates', this.templates);

		 // Add current order bound template to list 2 of 2
		 if(this.orderInitialTemplate){	
			 console.log("Push initialTemplate to templates stack 2of2:", this.orderInitialTemplate);
			 this.templates.unshift(this.orderInitialTemplate); //Prepend orderTemplate to first position
			 this.orderInitialTemplate = null;
		}
	 }
 }


  getTemplates(){
 
    return new Promise((resolve, reject) => {
 

 	this.storage.get('token').then((token) => {
	      let headers = new Headers();

	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);

	      let params = new URLSearchParams();
	      	params.append('with', 'swatches');
	 		//alert('Get Template with token:' + token);   
	      this.http.get(this.global.apiUrl+'templates', {headers: headers, params: params})
	        .map(res => res.json())
	        .subscribe(data => {
	      
	          resolve(data.data);
	        }, (err) => {
	          reject(err);
	        });
	    });
 	});
 
  }

  getTemplate(id){
 
    return new Promise((resolve, reject) => {
 

 	this.storage.get('token').then((token) => {
	      let headers = new Headers();

	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);

	      let params = new URLSearchParams();
	      //params.append('with', 'swatches');
	 		//alert('Get Template with token:' + token);
	      this.http.get(this.global.apiUrl+'templates/' + id, {headers: headers})
	        .map(res => res.json())
	        .subscribe(data => {
	      
	          resolve(data.data);
	        }, (err) => {
	          reject(err);
	        });
	    });
 	});
 
  }

  

  createPreview(template){
 
    return new Promise((resolve, reject) => {
 		this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);
	 		template.create_preview = true;

	 // 	setTimeout(() => 
		// {
		     this.http.post(this.global.apiUrl+'templates', JSON.stringify(template), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
		// },
		// 400);
	     


 		});
    });
 
  }

  updateTemplate(template){
 
    return new Promise((resolve, reject) => {
 		this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);
	 		template.banner_preview_image = null;
	      this.http.put(this.global.apiUrl+'templates/'+ template.id, JSON.stringify(template), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
 
  }
 
  createTemplate(template){
 
    return new Promise((resolve, reject) => {
 		this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);
	 		
	 		template.banner_preview_image = null;
	      this.http.post(this.global.apiUrl+'templates', JSON.stringify(template), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
 
  }
 
  deleteTemplate(id){
 	console.log("Delete for Template ID: ", id);
    return new Promise((resolve, reject) => {
 		this.storage.get('token').then((token) => {
			let headers = new Headers();
			headers.append('X-Requested-With', 'XMLHttpRequest');
	        headers.append('Authorization', 'Bearer ' + token);
			headers.append('X-localization', this.translate.currentLang);
			
	 
			this.http.delete(this.global.apiUrl+'templates/' + id, {headers: headers})
			.map(res => res.json()) 
			.subscribe((res) => {
	            resolve(res);
	        }, (err) => {
	            reject(err);
	        });   
 		}); 
    });
 
  }
 
}


// WEBPACK FOOTER //
// ./src/providers/templates/templates.ts